/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Hubeyebrow1Inputs */

const id_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const ms_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const da_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const de_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const en_us2_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const es_es2_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const es_mx2_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const fil_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const fr_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const it_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const hu_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const nl_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const no_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const pl_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const pt_br2_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const pt_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const ro_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const fi_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiekkalaatikko`)
};

const sv_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandlåda`)
};

const vi_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const tr_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const cs_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const bg_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const ru_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Песочница`)
};

const uk_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const ar_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const hi_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सैंडबॉक्स`)
};

const th_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แซนด์บ็อกซ์`)
};

const ja_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンドボックス`)
};

const zh_cn2_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沙盒`)
};

const zh_hant1_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沙盒`)
};

const ko_sandboxes_hubeyebrow1 = /** @type {(inputs: Sandboxes_Hubeyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

/**
* | output |
* | --- |
* | "Sandbox" |
*
* @param {Sandboxes_Hubeyebrow1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_hubeyebrow1 = /** @type {((inputs?: Sandboxes_Hubeyebrow1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Hubeyebrow1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_hubeyebrow1(inputs)
	if (locale === "ms") return ms_sandboxes_hubeyebrow1(inputs)
	if (locale === "da") return da_sandboxes_hubeyebrow1(inputs)
	if (locale === "de") return de_sandboxes_hubeyebrow1(inputs)
	if (locale === "en-US") return en_us2_sandboxes_hubeyebrow1(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_hubeyebrow1(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_hubeyebrow1(inputs)
	if (locale === "fil") return fil_sandboxes_hubeyebrow1(inputs)
	if (locale === "fr") return fr_sandboxes_hubeyebrow1(inputs)
	if (locale === "it") return it_sandboxes_hubeyebrow1(inputs)
	if (locale === "hu") return hu_sandboxes_hubeyebrow1(inputs)
	if (locale === "nl") return nl_sandboxes_hubeyebrow1(inputs)
	if (locale === "no") return no_sandboxes_hubeyebrow1(inputs)
	if (locale === "pl") return pl_sandboxes_hubeyebrow1(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_hubeyebrow1(inputs)
	if (locale === "pt") return pt_sandboxes_hubeyebrow1(inputs)
	if (locale === "ro") return ro_sandboxes_hubeyebrow1(inputs)
	if (locale === "fi") return fi_sandboxes_hubeyebrow1(inputs)
	if (locale === "sv") return sv_sandboxes_hubeyebrow1(inputs)
	if (locale === "vi") return vi_sandboxes_hubeyebrow1(inputs)
	if (locale === "tr") return tr_sandboxes_hubeyebrow1(inputs)
	if (locale === "cs") return cs_sandboxes_hubeyebrow1(inputs)
	if (locale === "bg") return bg_sandboxes_hubeyebrow1(inputs)
	if (locale === "ru") return ru_sandboxes_hubeyebrow1(inputs)
	if (locale === "uk") return uk_sandboxes_hubeyebrow1(inputs)
	if (locale === "ar") return ar_sandboxes_hubeyebrow1(inputs)
	if (locale === "hi") return hi_sandboxes_hubeyebrow1(inputs)
	if (locale === "th") return th_sandboxes_hubeyebrow1(inputs)
	if (locale === "ja") return ja_sandboxes_hubeyebrow1(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_hubeyebrow1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_hubeyebrow1(inputs)
	return ko_sandboxes_hubeyebrow1(inputs)
});
export { sandboxes_hubeyebrow1 as "sandboxes.hubEyebrow" }